import { useMutation } from 'react-query';
import { iteroCheckoutService } from 'services';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';
import { Dispatch, SetStateAction } from 'react';

export const useProceedToIteroCheckout = (
  proposalId: string,
  setProceedToCheckout: Dispatch<SetStateAction<boolean>>
) => {
  const i18n = useI18n();
  return useMutation(
    () => {
      return iteroCheckoutService.proceedToIteroCheckout(proposalId);
    },
    {
      onSuccess: (data, variables, context) => {
        setProceedToCheckout(true);
      },
      onError: () => {
        displayNotification(
          i18n['Something went wrong, Please refresh the page!'],
          'danger'
        );
      },
    }
  );
};
